export function appearingAnimation() {
    const _window = this.win;
    const elements = this.doc.querySelectorAll(".to-appear");
    let screenFactor = 0.85;
    let balkline = _window.innerHeight * screenFactor;
    let animateCoords = [];
    let scrolled = _window.pageYOffset || _window.scrollY;

    function getData() {
        animateCoords = [];
        [...elements].forEach( item => {
            let elementProps = item.getBoundingClientRect();
            animateCoords.push({
                self: item,
                top: Math.round(elementProps.top)
            });
        });
    }

    function animate() {
        scrolled = _window.pageYOffset || _window.scrollY;

        animateCoords.forEach( item => {
            if (item.top < scrolled + balkline) {
                if (item.self.classList.contains("to-appear")) {
                    item.self.classList.remove("to-appear");
                    item.self.classList.add("appeared");
                }
            }
        });
        
    }

    _window.addEventListener("load", () => {
        setTimeout(() => {
            getData();
            animate();
        }, 1000);
    });
    _window.addEventListener("scroll", () => {
        animate();
    });
    _window.addEventListener("resize", () => {
        getData();
        animate();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/appearing-animation.js